import { render, staticRenderFns } from "./TTCustomCommands.vue?vue&type=template&id=0b736716"
import script from "./TTCustomCommands.vue?vue&type=script&lang=js"
export * from "./TTCustomCommands.vue?vue&type=script&lang=js"
import style0 from "./TTCustomCommands.vue?vue&type=style&index=0&id=0b736716&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports